import { j as m } from "./index58.mjs";
import { Input as c } from "@mantine/core";
import d from "./index96.mjs";
import f from "./index97.mjs";
import { memo as p, forwardRef as u, useMemo as h } from "react";
import { CONTROLS as x } from "./index43.mjs";
import { getInputDefaults as C } from "./index5.mjs";
import { RichTextEditor as N } from "./index98.mjs";
d.register({ "modules/mention": f }, !0);
const k = p(
  u(({ users: o, ...t }, i) => {
    const r = C(t), n = h(
      () => o ? {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@"],
        showDenotationChar: !0,
        source: (a, s) => {
          const l = o.filter(
            (e) => e.displayName.toLowerCase().includes(a.toLowerCase())
          ).map((e) => ({
            id: e.id,
            value: e.displayName
          }));
          s(l);
        }
      } : void 0,
      [o == null ? void 0 : o.length]
    );
    return /* @__PURE__ */ m.jsx(c.Wrapper, { ...r, children: /* @__PURE__ */ m.jsx(
      N,
      {
        ref: i,
        controls: x,
        mentions: n,
        ...r,
        ...t,
        sx: (a) => ({
          backgroundColor: a.colors.dark[8]
        }),
        classNames: {
          ...r.classNames,
          ...t.classNames
        }
      }
    ) });
  }),
  (o, t) => o.value === t.value
);
export {
  k as RichText
};
